import React, { useCallback, useState } from 'react'
import { z } from 'zod'
import { zodToTs, printNode } from 'zod-to-ts'
import * as ts from "typescript";

const defaultExample = `
// Example schema / How to use.
// All references to Zod should only be named \`z\`
const articleFormSchema = z.object({
  title: z.string().min(1, { message: 'Title cannot be empty' }),
  caption: z.string().optional(),
  tags: z.string().min(1).array().optional(),
  exclude: z.string().min(1).array().optional(),
});

// Make sure to return the object you want to infer.
return articleFormSchema;

// Press "Generate" to generate schema.
`
export default function ZodToTS(props: { style?: React.CSSProperties }) {
  const { style } = props;
  const [input, setInput] = useState<string>(defaultExample);
  const [output, setOutput] = useState<string>('');

  const compute = useCallback((str: string) => {
    try {
      const zodSchema = eval(ts.transpile(`(function myfunc (z) { ${str} })`)); // wrap in a function to use the z from the outer scope
      console.log('eval is', zodSchema, typeof zodSchema);
      if (typeof zodSchema == 'function') {
        const resultSchema = zodSchema(z);

        setOutput(printNode(zodToTs(resultSchema).node));
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  return <div style={{ color: '#999' }}>
    <div style={{ padding: 0.2, backgroundColor: '#888', color: 'black' }}>
      <p>Generate Typescript types from Zod objects</p>
    </div>
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'stretch' }}>
        <p>Input</p>
        <textarea style={{ flex: 1, minHeight: 300 }} value={input} onChange={(e) => { setInput(e.target.value) }} />
      </div>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'stretch' }}>
        <p>Output</p>
        <textarea style={{ flex: 1, minHeight: 300 }} value={output} />
      </div>
    </div>
    <button onClick={() => {
      compute(input);
    }}>Generate!</button>
    <div style={{ padding: 8, backgroundColor: '#CCC', color: 'black' }}>
      <p>This is based on the brilliant work done by <a href={'https://www.npmjs.com/package/zod-to-ts'}>zod-to-ts</a> library!</p>
    </div>
  </div >
}

